export enum CookVerificationReportSeverity{
    Clear="Clear",
    Attention_Required="Attention Required", 
    Insufficient="Insufficient", 
    Discrepant="Discrepant"
}